import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import HotGossipGrid from './components/HotGossipGrid';
import CommentHighlights from './components/CommentHighlights';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeatureGrid />
        <HotGossipGrid />
        <CommentHighlights />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}